module.exports = __webpack_public_path__ + "img/ml3067.b430b426.png";